import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { HistoricoEscolar } from 'src/app/models/historicoEscolar';
import { BuscaService } from 'src/app/services/busca.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {

  ies: any;
  isLoading: boolean = false;
  logo: string;
  instituicoes: any;
  opened: boolean[] = [];
  buscaForm: UntypedFormGroup
  faq: any;
  pesquisarTipo: boolean[] = [false, false, false];
  indexBotao: number = null;
  botaoPesquisa: string[] = ["Ler QRCODE", "Buscar por Nome ou Número do Registro", "Buscar por Número de Registro"];
  botaoVoltar: boolean = false;
  diplomaDigital: HistoricoEscolar = null;

  erroDiploma: boolean = false;

  xmlFile: string;

  nomeArquivo: string = `historico_escolar_${new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()}.xml`;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _busca: BuscaService,
    private route: Router,
    private spinner: NgxSpinnerService
  ) {
    // Inicializa o FAQ
    this.faq = {
      "texto": "Busca de Informações de Registro de Histórico Em atendimento à Portaria MEC nº 1.095/2018, publicada no Diário Oficial da União em 26.10.2018, que dispõe sobre a expedição e o registro de diplomas de cursos superiores de graduação no âmbito do sistema federal de ensino, a $INSTITUICAO disponibiliza nesta página todos os Diplomas dos alunos que colaram grau a partir de 25.4.2019 para fins de verificação de autenticidade.",
      "duvidas": [
        {
          "duvida": "1. O que é o Histórico Escolar Digital?",
          "texto": "O Histórico Escolar Digital é o documento utilizado para fins de comprovação da integralização curricular de um determinado curso de graduação. O Histórico Escolar Digital é aquele que tem sua existência, sua emissão e seu armazenamento inteiramente no meio digital, e cuja validade jurídica é presumida mediante a assinatura com certificação digital e carimbo de tempo na Infraestrutura de Chaves Públicas Brasileira - ICP-Brasil, conforme os parâmetros do Padrão Brasileiro de Assinaturas Digitais – PBAD."
        },
        {
          "duvida": "2. Existe mais de um tipo de Histórico Escolar?",
          "texto": `Sim. Existem três tipos de Histórico Escolar, contudo apenas dois devem ser emitidos no formato digital (versão XML).<br>
                    - O Histórico Escolar de Simples Conferência pode ser emitido pela IES a qualquer tempo, não possui validade jurídica, não deve ser emitido observando as regras do Histórico Escolar Digital e pode ter o padrão próprio da IES, podendo ser emitido no formato PDF.<br>
                    - O Histórico Escolar Digital Parcial é emitido a qualquer tempo, possui validade jurídica e serve para comprovação do nível de integralização curricular.<br>
                    - O Histórico Escolar Digital Final é emitido a qualquer tempo, possui validade jurídica e deve ser entregue ao discente quando houver o encerramento do vínculo do discente com a IES.`
        },
        {
          "duvida": "3. Quando poderá ser solicitado o Histórico Escolar Digital?",
          "texto": "O Histórico Escolar de Simples Conferência e o Histórico Escolar Parcial podem ser solicitados a qualquer tempo. O Histórico Escolar Final será entregue ao discente quando houver o fim do vínculo acadêmico do discente com a IES."
        },
        {
          "duvida": "4. Como verificar a validade do Histórico Escolar Digital?",
          "texto": "A IES deve garantir a consulta e a validação do Histórico Escolar Digital bem como a disponibilidade de acesso ao ambiente virtual institucional por intermédio de um endereço eletrônico destinado exclusivamente a instituições de ensino, onde serão possíveis os acessos ao XML do Histórico Escolar bem como a geração e o download da Representação Visual do Histórico Escolar Digital (RVHE), a qualquer tempo. O uso do ICP-Brasil ao longo de todo o processo garante que o Histórico Escolar Digital tenha todas as garantias e a validade do documento físico. A diferença está na segurança e facilidade para verificação, que evita fraudes ao reforçar a segurança para registro e emissão de diplomas digitais. O MEC apenas acrescentou essa nova modalidade e deu ao Histórico Escolar Digital, por meio de portaria, a mesma validade que a versão impressa tinha."
        },
        {
          "duvida": "5. Os Históricos Escolares físicos já emitidos perderão sua validade com o Histórico Escolar Digital?",
          "texto": "Não. O Histórico Escolar físico já emitido não perde sua validade. A questão é que um Histórico Escolar já emitido e registrado de modo digital terá toda sua existência neste meio eletrônico. O Histórico Escolar digital é um documento oficial, juridicamente válido, tanto quanto o físico. Por ser um documento nato digital, será emitido e registrado no formato digital e sempre será acessado de forma eletrônica. Apesar de ser um documento em XML, haverá uma representação visual (RVHE) que será sua interface e, por meio de um QR Code ou uma URL, poderá ser validado digitalmente de forma prática, rápida e segura."
        },
        {
          "duvida": "6. Possuo Histórico Escolar Final Físico, terei que solicitar o Histórico Escolar Digital?",
          "texto": "Não. Os Históricos Escolares Finais emitidos no formato físico não precisam ser substituídos ou reemitidos. A partir do dia 1.9.2022, todas as Instituições de Ensino Superior deverão emitir seus Históricos Escolares no formato digital. Após esta implantação, as instituições não irão mais emitir os Históricos em formato físico para os cursos de graduação."
        },
        {
          "duvida": "7. É possível imprimir o Histórico Escolar Digital?",
          "texto": "É possível apenas imprimir a Representação Visual do Histórico Escolar Digital (RVHE)."
        },
        {
          "duvida": "8. A RVHE Digital impressa terá validade jurídica?",
          "texto": "Não, uma vez que só é possível assegurar a validade jurídica de documentos digitalmente assinados por meio da verificação da certificação digital, que é desenvolvida para o meio eletrônico. A assinatura digital é um conjunto de dados criptográficos incorporados a um documento. Desta forma, a validação da assinatura digital de um documento precisa ser feita no ambiente digital, uma vez que há necessidade de softwares e sistemas específicos para ler e compreender estes dados criptografados."
        },
        {
          "duvida": "9. O que é XML?",
          "texto": "O XML Público, além da Representação Visual do Histórico Escolar Digital – RVHE, é um conjunto de informações adicionais que o discente terá acesso ao buscar sua RVHE através do link disponibilizado pela IES, assim como: dados da IES emissora (Endereço da mantenedora, credenciamento e recredenciamento), informações sobre o discente e Informações sobre o curso (Autorização do curso, habilitação, reconhecimento e renovação)."
        },
        {
          "duvida": "10. O que é RVHE",
          "texto": "A RVHE é a Representação Visual do Histórico Escolar Digital, ou seja, é a interface entre o meio digital e o meio físico para o Histórico Escolar Digital, garantindo a qualidade da imagem e a integridade de seu Histórico Escolar Digital, preservando as características dos Históricos Escolares emitidos pela Instituição de Ensino. A RVHE, apesar de não ser o Histórico Escolar, apresenta uma interface que, com auxílio do QR-Code ou do código de validação, possibilita a autenticidade do documento de forma rápida, prática e segura. A Representação Visual do Histórico Escolar Digital deve zelar pela exatidão e fidedignidade das informações prestadas no XML do Histórico Escolar, bem como possibilitando ao diplomado exibir, compartilhar e armazenar esta imagem."
        },
        {
          "duvida": "11. Em caso de necessidade de entrega física do Histórico Escolar, como proceder?",
          "texto": "De acordo com os arts. 3° e 4° da Instrução Normativa nº 2, de 2.5.2022, c/c art. 1° da Instrução Normativa nº 4, de 1.7.2022, todas as Instituições de Ensino Superior deverão emitir seus Históricos Escolares no formato digital a partir de 1.9.2022. Após esta implantação, as instituições não irão mais emitir os Históricos Escolares em formato físico para os cursos de graduação."
        },
        {
          "duvida": "12. Participei de um concurso público e estão me pedindo o documento físico, o que devo fazer?",
          "texto": "É possível fazer a impressão da Representação Visual do Histórico Escolar Digital (RVHE), que não poderá ser considerada como o Histórico Escolar. A representação visual do Histórico Escolar Digital não substitui o Histórico Escolar Digital no padrão XML. A validação dessa impressão pode ser feita pelos dispositivos de validação em meio eletrônico, quais sejam: código de validação (disponível no canto inferior direito da frente do Histórico Escolar) ou QR Code (disponível na parte inferior direita da última página do Histórico Escolar)."
        },
        {
          "duvida": "13. Mesmo que haja pagamento de taxa extra, eu desejo meu Histórico Escolar Físico. Haverá essa possibilidade?",
          "texto": "Em atendimento à legislação, não haverá mais a emissão de Históricos Escolares físicos pela Instituição."
        },
        {
          "duvida": "14. Como terei acesso ao meu Histórico Escolar Digital?",
          "texto": "A solicitação e recebimento do histórico escolar para alunos Ativo, Trancado ou Transferido estará disponível no SIA Aluno, MENU Histórico Escolar."
        },
        {
          "duvida": "15. Existe custo para emissão do Histórico Escolar Digital?",
          "texto": "Não existe cobrança para emissão de Histórico Escolar Digital."
        },
        {
          "duvida": "16. A emissão do histórico escolar digital ocorrerá logo após a finalização do meu curso e sem necessidade de solicitação?",
          "texto": `Sim, sem necessidade de nenhuma solicitação. Ao concluir a colação de grau, o histórico escolar digital ficará disponível no seu SIA em até 60 dias.
                    Além disso, você receberá um e-mail informando sobre a disponibilidade do documento.<br>
                    Cabe ressaltar a importância de manter o e-mail e demais dados de contato atualizados, para que você receba esta e outras informações.`
        }
      ]
    };
  }

  ngOnInit(): void {
    // Define a IES
    if ('ies' in sessionStorage) {
      this.ies = JSON.parse(sessionStorage.getItem('ies'));
    }

    for (var i = 0; i < this.faq.duvidas.length; i++) {
      this.opened.push(false);
    }

    // Inicializa o form
    this.buscaForm = this.formBuilder.group({
      Codigo: ['', Validators.required]
    });
  }

  open(index: number) {
    this.opened[index] = !this.opened[index];
  }

  clicouPesquisar(index: number) {
    document.getElementById("texto-topo").classList.add('remove-texto');
    document.getElementById("subtexto-topo").classList.add('remove-texto');
    this.pesquisarTipo[index] = !this.pesquisarTipo[index];
    this.indexBotao = index;
    this.botaoVoltar = true;
  }

  clicouVoltar() {
    document.getElementById("texto-topo").classList.remove('remove-texto');
    document.getElementById("subtexto-topo").classList.remove('remove-texto');
    this.indexBotao = null;
  }

  buscaDigital(codigo: string) {
    this.route.navigate(['/hed/' + codigo]);

    //this.spinner.show();

    //this.isLoading = true;
    //this.erroDiploma = false;

    //this._busca.getHistorico(codigo, '').subscribe(response => {
    //  if (response.length > 0) {
    //    this.route.navigate(['/hed/' + codigo]);
    //  } else {
    //    // Esconde o loader
    //    this.spinner.hide();
    //    this.erroDiploma = true;
    //  }
    //}, error => {
    //  // Esconde o loader
    //  this.spinner.hide();
    //  this.erroDiploma = true;

    //  if (error.status === 404) {
    //    this.diplomaDigital = null;
    //  } else {
    //    console.log(error);
    //  }
    //});
  }

}
